<template>
  <Reference
    :id="value && value.id"
    :value="value"
    :total-items="totalItems"
    :label="label || 'Джерело Коштів'"
    :items.sync="items"
    component-name="PaymentSource"
    @input="$emit('input', $event)"
    @getItems="getItems"
  />
</template>

<script>
import * as sourcesApi from "@/backend/sourcesApi.js";
import Reference from "@/components/Reference";

export default {
  components: {
    Reference,
  },
  props: {
    label: {
      type: String,
      default: "Джерело Коштів",
    },
    value: {
      type: Object,
    },
    placeholder: {
      type: String,
      default: "Введіть найменування джерела коштів",
    },
  },
  data: () => ({
    items: [],
    totalItems: 0,
  }),
  methods: {
    async getItems({ currentPage, perPage, search }) {
      const { result, totalItems } = await sourcesApi.selectPaymentSource(
        currentPage,
        perPage,
        search
      );
      this.items = [...this.items, ...result];
      this.totalItems = totalItems;
    },
  },
};
</script>
